var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import ApiConfig from "./api-config";
import ApiI18Config from "./api-i18-config";
var Api = {};
export var ApiI18 = {
    checkEmail: function (params) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, ApiConfig.post('api/v2/users/check-email', params, { responseType: "json" })];
    }); }); },
    compositeBackdrop: function (params) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, ApiConfig.put("api/v2/backdrops/".concat(params.backdropId, "/recomposite"), params, { responseType: "json" })];
    }); }); },
    customBackdrops: function (data) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, ApiConfig.post("api/v2/backdrops/customBackdrops", data, { "Content-Type": "multipart/form-data" })];
    }); }); },
    fetchCountriesList: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, ApiConfig.get("api/v2/settings/countries", {}, { responseType: "json" })];
    }); }); },
    fetchLangData: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, ApiI18Config.get("api/v2/i18n/front20?category=FRONT", {}, { responseType: "json" })];
    }); }); },
    fetchLangsList: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, ApiI18Config.get("api/v2/i18n/react/info", {}, { responseType: "json" })];
    }); }); },
    fetchLogin: function (params) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, ApiConfig.post("api/v2/auth/login", params, { responseType: "json" })];
    }); }); },
    forgotPassword: function (params) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, ApiConfig.post('api/v2/users/forgot-password', params)];
    }); }); },
    gadArt: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, ApiConfig.get('api/v2/backdrops/gadArt', {}, { responseType: "json" })];
    }); }); },
    getGadArtExamples: function (params) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, ApiConfig.get('api/v2/images', undefined, { params: params })];
    }); }); },
    getListBackdrops: function (params) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, ApiConfig.get('api/v2/backdrops/list', undefined, { params: params })];
    }); }); },
    getMe: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, ApiConfig.get('api/v2/users/me', {}, { responseType: "json" })];
    }); }); },
    getMyBackdropOrders: function (params) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, ApiConfig.get('api/v2/backdrops/orders', undefined, { params: params })];
    }); }); },
    getMyBackdrops: function (params) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, ApiConfig.get('api/v2/backdrops', undefined, { params: params })];
    }); }); },
    getSettingByParams: function (params) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, ApiConfig.get("api/v2/settings/".concat(params._id), {}, { responseType: "json" })];
    }); }); },
    resetPassword: function (params) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, ApiConfig.post('api/v2/users/change-password', params)];
    }); }); },
    signUpUser: function (params) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, ApiConfig.post('api/v2/users/signup', params, { responseType: "json" })];
    }); }); },
    verifyCaptcha: function (data) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, ApiConfig.post("api/v2/manage/verify-captcha", data, { responseType: "json" })];
    }); }); },
};
export var getResponseErrorMessage = function (err) {
    var message = "";
    try {
        var data = err.response.data && typeof err.response.data === "object"
            ? err.response.data
            : typeof err.response.data === "string"
                ? JSON.parse(err.response.data)
                : { message: "Unknown error" };
        if ("message" in data) {
            message = data.message;
        }
        else if ("error" in data) {
            message = data.error;
        }
    }
    catch (e) {
        message = "Unknown error";
    }
    return message;
};
export default Api;
